package one.healthium.profile.navigation.update_weight

import androidx.compose.runtime.Composable
import one.healthium.profile.ui.update_weight.UpdateWeightScreen

@Composable
fun UpdateWeightContent(component: UpdateWeightComponent) {
    UpdateWeightScreen(component.weight, component.date, component)
}